export const STATE_NAME = 'marketsettings';

export const FETCH_MARKET_SETTINGS = 'FETCH_MARKET_SETTINGS';
export const FETCH_MARKET_SETTINGS_DONE = 'FETCH_MARKET_SETTINGS_DONE';
export const FETCH_MARKET_SETTINGS_FAIL = 'FETCH_MARKET_SETTINGS_FAIL';
export const ONCHANGE_MARKET_SETTINGS_DATA = 'ONCHANGE_MARKET_SETTINGS_DATA;';

export const SAVE_MARKET_SETTINGS = 'SAVE_MARKET_SETTINGS';
export const SAVE_MARKET_SETTINGS_DONE = 'SAVE_MARKET_SETTINGS_DONE';
export const SAVE_MARKET_SETTINGS_FAIL = 'SAVE_MARKET_SETTINGS_FAIL';
